
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { TrackingArrayItemsVariazione } from '@/models';

@Component
export default class ItemListVariazioneArrayItemsOrdineMTM extends Vue {
    @Prop() private variazione!: TrackingArrayItemsVariazione;
    @Prop() private displayProperty!: string;

    @Emit('conferma-variazione')
    private confermaVariazione()
    {
        return this.variazione.id;
    }
}
